import { render, staticRenderFns } from "./TitleSummaryCard.vue?vue&type=template&id=2dfae3f6&"
import script from "./TitleSummaryCard.vue?vue&type=script&lang=js&"
export * from "./TitleSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports